import styled from 'styled-components'

export const Content = styled.div`
	text-align: left;

	@media only screen and (max-width: 1010px) {
		text-align: center;
		width: 100%;
	}
`
